<div class="reset-password-container">
    <h4 translate>Reset password</h4>
    <p></p>
</div>